/* Every icon is a 24x24 stroked SVG; `fill` marks the solid bits. A primitive,
   so it sits in the `primitives` cascade layer — see `styles/global.css`. */

@layer primitives {
  .ico {
    width: 20px;
    height: 20px;
    display: block;
    fill: none;
    stroke: currentcolor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .ico :global(.fill) {
    fill: currentcolor;
    stroke: none;
  }
}
